<template>
  <div>
    <div v-for="(icon, index) in iconList" :key="index">
      <div v-html="icon"></div>
    </div>
    <sa-form :model="formData">
      <sa-form-item label="图标大小">
        <sa-input-number
          v-model="formData.size"
          :min="12"
          :max="48"
          @change="handleConfigChange"
        ></sa-input-number>
      </sa-form-item>
      <sa-form-item label="线段粗细">
        <sa-input-number
          v-model="formData.strokeWidth"
          :min="1"
          :max="4"
          @change="handleConfigChange"
        ></sa-input-number>
      </sa-form-item>
      <sa-form-item label="图标风格">
        <sa-radio-group v-model="formData.theme" @change="handleConfigChange">
          <sa-radio label="outline">线性</sa-radio>
          <sa-radio label="filled">面性</sa-radio>
          <sa-radio label="two-tone">双色</sa-radio>
          <sa-radio label="multi-color">多色</sa-radio>
        </sa-radio-group>
      </sa-form-item>
      <sa-form-item label="端点类型">
        <sa-radio-group v-model="formData.strokeLinecap" @change="handleConfigChange">
          <sa-radio label="butt">butt</sa-radio>
          <sa-radio label="round">round</sa-radio>
          <sa-radio label="square">square</sa-radio>
        </sa-radio-group>
      </sa-form-item>
      <sa-form-item label="拐点类型">
        <sa-radio-group v-model="formData.strokeLinejoin" @change="handleConfigChange">
          <sa-radio label="miter">miter</sa-radio>
          <sa-radio label="round">round</sa-radio>
          <sa-radio label="bevel">bevel</sa-radio>
        </sa-radio-group>
      </sa-form-item>
      <sa-form-item label="描边颜色">
        <sa-color-picker v-model="formData.colors[0]" @change="handleConfigChange"></sa-color-picker>
      </sa-form-item>
      <sa-form-item label="填充颜色">
        <sa-color-picker v-model="formData.colors[1]" @change="handleConfigChange"></sa-color-picker>
      </sa-form-item>
    </sa-form>
    {{formData.colors}}
  </div>
</template>
<script>
import icons from '@/packages/svg/index';
export default {
    data() {
      return {
        formData: {
          size: 48,
          strokeWidth: 4,
          strokeLinecap: 'butt', // 端点
          strokeLinejoin: 'miter', // 拐点
          theme: 'outline',
          isCurrentColor: false,
          colors: ['#333', '#2F88FF', '#FFF', '#43CCF8'], // 自定义颜色
        },
        iconList: [],
      }
    },
    methods: {
      handleConfigChange() {
        this.iconList = icons.map(icon => {
          return icon.render(this.formData);
        })
      },
    },
    created() {
      this.handleConfigChange();
    }
}
</script>